var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "cemetery-occupation-item",
      class: { "cursor-default": !_vm.enableView },
    },
    [
      _c(
        "div",
        {
          staticClass: "occupation-wrapper",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.onView.apply(null, arguments)
            },
          },
        },
        [
          _c("span", { staticClass: "occupation-id" }, [
            _vm._v(_vm._s(_vm.number)),
          ]),
          _vm._v(" "),
          _vm.hasPersons
            ? [
                _c("span", { staticClass: "occupation-persons" }, [
                  _vm._v(
                    "\n                 " +
                      _vm._s(_vm.textPersons) +
                      "\n             "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "occupation-quantity" }, [
                  _c("span", { staticClass: "person-icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "100%",
                          height: "100%",
                          viewBox: "0 0 16 16",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                          fit: "",
                          preserveAspectRatio: "xMidYMid meet",
                          focusable: "false",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M11.2875 4.11067C11.6569 6.33744 9.73611 8.26726 7.4459 7.97036C6.04222 7.74769 4.93405 6.63434 4.71242 5.22405C4.34303 2.99729 6.26385 1.06737 8.48019 1.36427C9.95774 1.51272 11.1398 2.70039 11.2875 4.11067Z",
                            stroke: "#181429",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M2 13.334V11.6673C2 11.4673 2.07059 11.2673 2.28235 11.134C2.91765 10.6006 4.89412 9.33398 8 9.33398C11.1059 9.33398 13.0824 10.6006 13.7176 11.134C13.8588 11.2673 14 11.4673 14 11.6673V13.334C14 13.734 13.7176 14.0007 13.2941 14.0007H2.70588C2.28235 14.0007 2 13.734 2 13.334Z",
                            stroke: "#181429",
                            "stroke-width": "1.5",
                            "stroke-miterlimit": "10",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "quantity-number" }, [
                    _vm._v(_vm._s(_vm.numPersons)),
                  ]),
                ]),
              ]
            : [
                _c("span", { staticClass: "occupation-label vacant" }, [
                  _vm._v(" " + _vm._s(_vm.state) + " "),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      false
        ? _c("div", { staticClass: "occupation-actions" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-link btn-block text-left",
                attrs: { type: "button", "aria-label": `view ${_vm.number}` },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onOpenSector.apply(null, arguments)
                  },
                },
              },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-link btn-block text-left",
                attrs: {
                  type: "button",
                  "aria-label": `view on map ${_vm.number}`,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onViewOnMap.apply(null, arguments)
                  },
                },
              },
              [_vm._m(1)]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "button-wrapper" }, [
      _c("i", { staticClass: "fas fa-pencil" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "button-wrapper" }, [
      _c("i", { staticClass: "fas fa-location-dot" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }